angular.module('app').service('appUtils', function($http, $mdDialog, $mdToast, $q, $timeout, $rootScope) {
    return {
        'load': function(name, id) {
            var url = '/api/v1/admin/' + name;
            if(id) {
                url += '/' + id;
            }
            return $http({'method': 'GET', 'url': url});
        },
        'arrayMove': function(target, old_index, new_index) {
            target.splice(new_index, 0, target.splice(old_index, 1)[0]);
        },
        'inArray': function(target, key, collection) {
            return this.indexOf(target, key, collection) > -1;
        },
        'indexOf': function(target, key, collection) {
            return collection.findIndex(function(item) {
                return target[key] == item[key];
            });
        },
        'toggleArrayItem': function(target, key, collection) {
            var idx = this.indexOf(target, key, collection);
            if(idx > -1) {
                return collection.splice(idx, 1);
            } else {
                collection.push(target);
                return collection;
            }
        },
        'remove': function(target, key, collection) {
            var idx;
            if(typeof target[key] === 'undefined') {
                idx = collection.indexOf(target);
            } else {
                idx = this.indexOf(target, key, collection);
            }
            if(idx > -1) {
                return collection.splice(idx, 1);
            }
        },
        'delete': function(name, target, collection) {
            var util = this;
            if(!target.id) {
                return util.remove(target, 'id', collection);
            }
            return $http({
                'method': 'DELETE',
                'url': '/api/v1/admin/' + name + '/' + target.id
            }).then(
                function(response) {
                    util.remove(target, 'id', collection);
                }
            );
        },
        'filter': function(query) {
            var params = this.emptyQuery();
            params.q.filters.push(query);
            return params;
        },
        'encode': function(string) {
            return encodeURIComponent(string);
        },
        'emptyQuery': function() {
            return {
                    'q': {
                        'filters': []
                    },
                    'results_per_page': 50
                };
        },
        'orSearch': function(name, fields, text, params) {
            if(params == null) {
                params = this.emptyQuery();
            }

            var orQuery = {'or': []};
            fields.forEach(function(field) {
                orQuery.or.push({
                    'name': field,
                    'op': 'ilike',
                    'val': '%' + text + '%'
                });
            });
            params.q.filters.push(orQuery);
            return this.search(name, text, params, true);
        },
        'search': function(name, text, params, skipFilter) {
            if(params == null) {
                params = this.emptyQuery();
            }

            if(!skipFilter && text) {
                var id = Number(text) ;
                var filters = params.q.filters;
                if(Number.isInteger(id)) {
                    var orQuery = {'or': []};
                    params.q.filters.push(orQuery);
                    filters = orQuery.or;
                    filters.push({
                        'name': 'id',
                        'op': 'eq',
                        'val': text
                    });
                }

                filters.push({
                    'name': 'name',
                    'op': 'ilike',
                    'val': '%' + text + '%'
                });
            }

            return $http({'method': 'GET', 'url': '/api/v1/admin/' + name, 'params': params}).then(
                function(response) {
                    return response.data.objects;
                }
            );
        },
        'quickDialog': function(ctrl, template, locals) {
            opts = {
                'controller': ctrl,
                'controllerAs': 'main',
                'templateUrl': template,
                'clickOutsideToClose': true,
                'multiple': true,
            };
            if(locals) {
                opts.locals = locals;
                opts.bindToController = true;
            }
            return $mdDialog.show(opts);
        },
        'embedNew': function(ctrl, template, collection) {
            return $mdDialog.show({
                'controller': ctrl,
                'controllerAs': 'main',
                'templateUrl': template,
                'multiple': true,
                'clickOutsideToClose': true,
                'locals': {'id': 'new', 'embedded': true},
                'bindToController': true
            }).then(
                function(item) {
                    collection.push(item);
                    return item;
                }
            );
        },
        'addUniqueOnSelect': function(parent, key, collection, compare_key) {
            if(!parent[key]) {
                return;
            }
            var keys = collection.map(function(item) {
                return item[compare_key];
            });

            if(keys.includes(parent[key][compare_key])) {
                var alert = $mdToast.simple().textContent("That item is already included.");
                $mdToast.show(alert);
            } else {
                this.addOnSelect(parent, key, collection);
            }
        },
        'toast': function(message, theme) {
            var alert = $mdToast.simple().textContent(message);
            if(theme) {
                alert.theme(theme);
            }
            $mdToast.show(alert);
        },
        'addOnSelect': function(parent, key, collection) {
            if(parent[key]) {
                collection.push(parent[key]);
                parent[key] = null;
            }
        },
        'fileReaderDownload': function(contentType, fileName, content) {
            var blob = new Blob([ content ], { type : contentType });
            if(navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, fileName);
            } else {
                url = (window.URL || window.webkitURL).createObjectURL( blob );
                save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                save_link.href = url;
                save_link.download = fileName;
                var event = document.createEvent("MouseEvents");
                event.initMouseEvent(
                        "click", true, false, window, 0, 0, 0, 0, 0,
                        false, false, false, false, 0, null
                        ); 
                save_link.dispatchEvent(event);
            }
        },
        'fileReaderUpload': function(url, content_type, file) {
            var fr = new FileReader();
            var defer = $q.defer();

            fr.onload = function(e) {
                $http({
                    url: url,
                    method: 'PUT', 
                    headers: {'Content-Type': content_type}, 
                    data: new Uint8Array(fr.result), 
                    transformRequest: []
                }).then(
                    defer.resolve,
                    defer.reject
                );
            };
            fr.readAsArrayBuffer(file);

            return defer.promise;
        },
        'loadWiw': function(target, main, franchise_id) {
            if(!main.wiw_fetched) {
                main.wiw_fetched = {};
            }
            
            if(!main.wiw_data) {
                main.wiw_data = {};
            }
            
            if(main.wiw_fetched[target] === true) {
                return;
            }

            if(!franchise_id) {
                franchise_id = $rootScope.franchiseSwitcher.activeFranchise().id;
            }

            $http.get(
                '/api/v1/admin/franchise/' + franchise_id + '/when-i-work/' + target
            ).then(function(response) {
                main.wiw_fetched[target] = true;
                $timeout(function() {
                    main.wiw_data[target] = response.data;
                }, 0);
            });
        }

    };
});
